import { Card, CardContent } from "@/components/ui/card";
import {
  Handshake, UserPlus, Users, DollarSign, Landmark, Megaphone,
  ChevronRight, BookOpen
} from "lucide-react";

export function NetworkingLoungeZone({
  setActiveZone,
  setOpportunityFilter,
  fetchOpportunities
}) {
  return (
    <div className="space-y-6">
      {/* How-to Instructions Card */}
      <Card className="bg-gradient-to-r from-cyan-500/10 to-neutral-900/50 border-cyan-500/20">
        <CardContent className="pt-6">
          <div className="flex items-start gap-4">
            <div className="w-10 h-10 bg-cyan-500/20 rounded-lg flex items-center justify-center flex-shrink-0">
              <BookOpen className="w-5 h-5 text-cyan-400" />
            </div>
            <div className="flex-1">
              <h3 className="font-semibold text-white mb-2">How to Use the Networking Lounge</h3>
              <ul className="text-sm text-neutral-300 space-y-2">
                <li className="flex items-start gap-2">
                  <span className="text-cyan-400 font-bold">1.</span>
                  <span><strong>Choose a category</strong> - Select the type of connection you're seeking (partnerships, referrals, funding, etc.)</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-cyan-400 font-bold">2.</span>
                  <span><strong>Browse opportunities</strong> - Click any category to see open requests from members</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-cyan-400 font-bold">3.</span>
                  <span><strong>Reach out directly</strong> - Message interested parties to explore collaboration</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-cyan-400 font-bold">4.</span>
                  <span><strong>Post your own needs</strong> - Create opportunities to attract the right partners</span>
                </li>
              </ul>
            </div>
          </div>
        </CardContent>
      </Card>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
        {[
          { type: "partnership", label: "Partnerships & Collaborations", icon: Handshake, color: "emerald" },
          { type: "referral", label: "Referral Exchange", icon: UserPlus, color: "blue" },
          { type: "hiring", label: "Hiring & Talent", icon: Users, color: "purple" },
          { type: "funding", label: "Funding & Investors", icon: DollarSign, color: "amber" },
          { type: "government", label: "Government & Contracts", icon: Landmark, color: "slate" },
          { type: "marketing", label: "Marketing & Exposure", icon: Megaphone, color: "pink" }
        ].map((channel) => {
          const Icon = channel.icon;
          return (
            <Card
              key={channel.type}
              className="bg-neutral-800/50 border-neutral-700 hover:border-[#39FF14]/50 transition-all cursor-pointer"
              onClick={() => {
                setActiveZone("marketplace");
                setOpportunityFilter(channel.type);
                fetchOpportunities(channel.type);
              }}
            >
              <CardContent className="pt-6">
                <div className="flex items-center gap-4">
                  <div className={`w-12 h-12 bg-${channel.color}-500/10 rounded-lg flex items-center justify-center`}>
                    <Icon className={`w-6 h-6 text-${channel.color}-400`} />
                  </div>
                  <div className="flex-1">
                    <h3 className="font-semibold text-white">{channel.label}</h3>
                    <p className="text-sm text-neutral-400">View opportunities</p>
                  </div>
                  <ChevronRight className="w-5 h-5 text-neutral-500" />
                </div>
              </CardContent>
            </Card>
          );
        })}
      </div>
    </div>
  );
}
